import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "dividerColor", "gap"];
import styled from 'styled-components';
import { LayoutSpaceVertical } from './LayoutSpaceVertical';
import { makeBorderCustomProperty } from './utils';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DividerContainer = styled(LayoutSpaceVertical).withConfig({
  displayName: "LayoutDividerVertical__DividerContainer",
  componentId: "sc-13ifjbt-0"
})(["> *{position:relative;}>:not(:last-child){margin-block-end:calc(var(--layout-lib-space-gap) * 2);}>:not(:last-child)::after{", " content:'';display:block;inset-block-end:calc( var(--layout-lib-space-gap) * -1 - var(--layout-lib-border-width) );inset-inline:0;position:absolute;width:100%;z-index:1;}"], ({
  $dividerColor
}) => $dividerColor && `border-block-end: ${makeBorderCustomProperty($dividerColor)};`);
export const LayoutDividerVertical = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as,
      children,
      dividerColor = 'border',
      gap = 'space-lg'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(DividerContainer, Object.assign({}, rest, {
    $dividerColor: dividerColor,
    forwardedAs: as,
    gap: gap,
    ref: ref,
    children: children
  }));
});